// extracted by mini-css-extract-plugin
export default {"logo":"HeaderOne_logo__S5bSu","logoimg":"HeaderOne_logoimg__Z+Q1P","logosub":"HeaderOne_logosub__UXHKa"};